import React, { useState, useContext, useEffect, useRef } from "react";
import { useSpring, animated } from "react-spring";
import { v4 as uuidv4 } from "uuid";
import { Check } from "react-feather";

import { FileUploaderButton } from "../../Components/FileUploaderButton";
import { languages } from "../../Data/languages";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { useEnterKey } from "../../Hooks/useEnterKey";
import { AuthContext } from "../../Context/AuthContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";

import TopBar from "../../Components/TopBar";
import NewButton from "../../NewComponents/NewButton";
import SecureAndPrivate from "../../NewComponents/SecureAndPrivate";
import LogoAuthNavbar from "../../NewComponents/LogoAuthNavbar";
import CreateOrderNav from "../../NewComponents/CreateOrderNav";
import SearchSelect from "../../NewComponents/SearchSelect";

import AddCommentonDocument from "../../NewComponents/AddComment/AddCommentonDocument";
import "./QuoteDetails.css";
import { storage } from "../../firebase.config";

const QuoteDetails = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();
  const { showNotification } = useContext(NotificationContext);

  const { signedIn } = useContext(AuthContext);

  const { quote, setQuote } = useContext(DataContext);
  
  const quoteID = useRef();

  const [focus, setFocus] = useState({
    languageFrom: false,
    languageTo: false,
  });

  useEffect(() => {
    setCertified(quote.certified === false ? quote.certified : true);
    setLanguageFrom(quote.languageFrom || '');
    setLanguageTo(quote.languageTo || '');
    setFiles(quote.files || []);
  }, [quote]);

  useEffect(() => {
    quoteID.current = uuidv4();

    if (
      (windowSize.width > 767 || windowSize.orientation === "landscape") &&
      document.getElementById("mainPrimary") &&
      document.getElementById("mainSecondary")
    ) {
      document.getElementById("mainSecondary").style.height = `${document.getElementById("mainPrimary").clientHeight
        }px`;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [certified, setCertified] = useState(true);

  const [languageFrom, setLanguageFrom] = useState("");
  const [languageTo, setLanguageTo] = useState("");

  const certifiedProps = useSpring({ borderColor: certified ? '#12ABBF' : '#E6E7E9' });
  const standardProps = useSpring({ borderColor: !certified ? '#12ABBF' : '#E6E7E9' });

  const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [addComment, showAddComment] = useState(false);
  
     useEffect(() => {
        if(languageFrom !== "" && languageFrom !== "english" && languageTo === ""){
          setLanguageTo("english");
    
        }
      }, [languageFrom])
    

  const handleFiles = (e) => {
    const now = new Date();
    const mFiles = e.target.files;

    for (let i = 0; i < mFiles.length; i++) {
      const fileID = uuidv4();
      setFiles(f => f.concat([{ id: fileID, name: mFiles[i].name, file: mFiles[i], progress: 0, status: 'uploading' }]));
    }

    const storageRef = storage.ref();

    for (let i = 0; i < mFiles.length; i++) {
      const subFolder = uuidv4();
      const fileRef = storageRef.child(quoteID.current + '/' + subFolder + '/' + mFiles[i].name);

      const downloadToken = uuidv4();

      const fileName = mFiles[i].name.replace('#', '%23').replace('+', "%2b");

      const url = `${process.env.REACT_APP_STORAGE_URL}/o/${quoteID.current}%2F${subFolder}%2F${fileName}?alt=media&token=${downloadToken}`;

      var metadata = {
        firebaseStorageDownloadTokens: downloadToken,
        customMetadata: {
          'quoteID': quoteID.current
        }
      }

      const uploadTask = fileRef.put(mFiles[i], metadata);

      setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, task: uploadTask } : file));

      uploadTask.on('state_changed', (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, progress: progress.toFixed(2) } : file));
      }, (error) => {
        // setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'failed' } : file));
        setFiles(f => f.filter(file => file.name !== mFiles[i].name && file.ref !== mFiles[i].ref));
        showNotification("Error uploading.", "There was an error uploading the file " + mFiles[i].name + ". Please, try again.", "error");
      }, () => {
        /*uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          setFiles(f => f.map(file => file.name === mFiles[i].name ? { ...file, status: 'complete', ref: oID + '/' + subFolder + '/' + mFiles[i].name, url: downloadURL } : file));
        });*/
        setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'complete', ref: quoteID.current + '/' + subFolder + '/' + mFiles[i].name, url: url, timestamp: now.getTime() } : file));

      });
      // }
    }
  }

  const handleDeleteFile = async (file) => {
    const checkFile = (file1, file2) => {
      if(file1.id && file2.id){
        return file1.id === file2.id;
      }
      if(file1.ref && file2.ref){
        return file1.ref === file2.ref;
      }
    }
    const storageRef = storage.ref();

    if (file.ref && (file.status === "complete" || file.timestamp)) {
      const fileRef = storageRef.child(file.ref);
      setFiles((f) =>
        f.map((mFile) =>
          mFile.name === file.name && checkFile(mFile, file)
            ? { ...mFile, status: "deleting" }
            : mFile
        )
      );

      fileRef
        .delete()
        .then(function () {
          setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
        })
        .catch(function (error) {
          showNotification(
            "Error deleting the file.",
            "There was an error deleting the file " +
              file.name +
              ". Please, try again.",
            "error"
          );
        });
    } else if (file.status === "failed") {
      setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    } else {
      file.task.cancel();
      setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    }
  };
  

  const handleContinueToOptions = () => {
    localStorage.setItem('quote', JSON.stringify({ ...quote, certified: certified, languageFrom: languageFrom, languageTo: languageTo, files: JSON.stringify(files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name,id: file.id, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp }))) }));
    setQuote(q => ({ ...q, certified: certified, languageFrom: languageFrom, languageTo: languageTo, files: files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name,id: file.id, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp })) }));
    transitionTo('/quote/options');
  }

  const triggerContinue = () => {
    if (
      !(
        (!signedIn && !quote.name) ||
        languageFrom === "" ||
        languageTo === "" ||
        files.length === 0 ||
        files.some((file) => file.status !== "complete") ||
        (certified)
      )
    ) {
      handleContinueToOptions();
    }
  };

  useEnterKey(() => triggerContinue());

  const handleFocusLanguageFrom = (isFocused) => {
    setFocus({ languageFrom: isFocused, languageTo: false });
  };

  const handleFocusLanguageTo = (isFocused) => {
    setFocus({ languageFrom: false, languageTo: isFocused });
  };

  const handleAddComment = (file) => {

    setSelectedFile(file);
    showAddComment(true);
  };

  const handleAddCommentClose = () => {
    showAddComment(false);
    setSelectedFile(null);
  };
  

  const handleSetTraslationType = (isCertified) => {
    setCertified(isCertified);

    localStorage.setItem('quote', JSON.stringify({ parsed: true, certified: isCertified, languageFrom: languageFrom, languageTo: languageTo, files: JSON.stringify(files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name,id: file.id, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp }))) }));
    setQuote(q => ({ parsed: true, certified: isCertified, languageFrom: languageFrom, languageTo: languageTo, files: files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name,id: file.id, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp })) }));
  }


  return (
    <>
      <TopBar />

      <div className="mainOrderContainer">
      {!addComment && 
        <div className="mainOrderHeader">
          <LogoAuthNavbar isAuth={signedIn}  showButtons={false} />
        </div>
      }
        { 
          !addComment &&
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <CreateOrderNav title="1. Details" stage={1} stages={3} />
            <div></div>
          </div>
        </div>
        }
        {addComment && (
          <AddCommentonDocument selectedFile={selectedFile}  handleClose={handleAddCommentClose} quoteInfo={quote} />
        )}
        {
          !addComment &&
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <div id="mainPrimary" className='mainOrderPrimaryContent'>
              <div className='quotePrimaryOptionsWrapper'>
                <h4 className="quotePrimaryTitle">What type of translation do you need?</h4>
                <div className="quotePrimaryOptions">
                  <animated.div style={certifiedProps} className="quotePrimaryOption" onClick={() => handleSetTraslationType(true)}>
                    <div className='quotePrimaryOptionTitleWrap'>
                      <p className="quotePrimaryOptionTitle">Certified Translation</p>
                      <p className="quotePrimaryOptionTitle">$24.95/page</p>
                    </div>
                    <p className="quotePrimaryOptionText">Includes our certification for official use with legal and institutional entities, such as USCIS, courts, and universities.</p>
                  </animated.div>
                  <animated.div style={standardProps} className="quotePrimaryOption" onClick={() => handleSetTraslationType(false)}>
                    <div className='quotePrimaryOptionTitleWrap'>
                      <p className="quotePrimaryOptionTitle">Standard Translation</p>
                      <p className="quotePrimaryOptionTitle">$24.95/page</p>
                    </div>
                    <p className="quotePrimaryOptionText">For business and personal purposes, including CVs, client intake forms, and marketing materials for your business.</p>
                  </animated.div>
                </div>
              </div>

              <div className='quotePrimaryOptionsWrapper'>
                <h4 className="quotePrimaryTitle">What language pair do you need translated?</h4>
                <p className="quoteSmallMessage">Either the source or target language must include English. Please contact us for language pairs without English.</p>
                <div className="quoteDetailsInputsContainer">
                  <SearchSelect
                    list={languages.filter(language => languageTo === 'english' || languageTo === '' || language.value === 'english')}
                    placeholder="From"
                    value={languageFrom}
                    focus={focus.languageFrom}
                    setValue={setLanguageFrom}
                    setFocus={handleFocusLanguageFrom}
                  />
                  <SearchSelect
                    list={languages.filter(language => languageFrom === 'english' || languageFrom === '' || language.value === 'english')}
                    placeholder="To"
                    value={languageTo}
                    focus={focus.languageTo}
                    setValue={setLanguageTo}
                    setFocus={handleFocusLanguageTo}
                  />
                </div>
              </div>

              <div className='quotePrimaryOptionsWrapper'>
                <h4 className="quotePrimaryTitle">Upload the files you need translated</h4>
                <div className="quoteDetailsFileUploaderContainer">
                  <FileUploaderButton display text="Choose Files" files={files} handleAddComment={handleAddComment} handleFiles={handleFiles} handleDeleteFile={handleDeleteFile} fontSize={windowSize.width > 1024 ? 1.1 : windowSize.width > 767 ? (windowSize.orientation === 'portrait' ? 1.6 : 1.1) : (windowSize.orientation === 'portrait' ? 5 : 1.5)} />
                </div>
              </div>

              <div>
                <div className="quoteSubmitButtonContainer">
                  <NewButton text="Continue to Services" disabled={languageFrom === '' || languageTo === '' || files.length === 0 || files.some(file => file.status !== 'complete')} onClick={() => handleContinueToOptions()} />
                </div>
              </div>


            </div>
          </div>

          <div className='mainOrderSecondaryContent'>
            <div className='mainOrderSecondaryContentWrap relative'>
              <div className="orderSummary">
                <h3 className="quotePrimaryTitle">WHAT TO EXPECT</h3>
                <div className="quoteSecondarySub">
                  We’ll respond quickly with a formal quote covering the cost and
                  turnaround time for your translation project.
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Free quote, no obligation to buy
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Final pricing with no surprises
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Estimated turnaround time
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Quick convert to order when ready
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Quote is guaranteed for 30 days
                  </div>
                </div>
              </div>
              <div>
                <SecureAndPrivate />
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </>
  );
};

export default QuoteDetails;
